import { render, staticRenderFns } from "./Armazenar.vue?vue&type=template&id=a13e7ea4"
import script from "./Armazenar.vue?vue&type=script&lang=js"
export * from "./Armazenar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports